export default __webpack_public_path__ + "static/media/feb2023-5.d53761d4.jpg";